module.exports = "\n  \n  \n  .paragraphDiv{\n      margin-top: 3%;\n  }\n  .parent-info{\n    font-size:  10px;\n    padding-top: 3px;\n    color: #5DA51B !important;\n}\n  @media screen and (max-width: 450px) {\n     .paragraphDiv{\n             width: 105px;\n     }\n        .paragraph{\n     font-size: 12px;\n     margin-left: 17px;\n     /* width: 100%; */\n     margin-top: 12%;\n    }\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/song-info/song-info-nexttrack/song-info-nexttrack.component.css
// module id = ./src/app/player/song-info/song-info-nexttrack/song-info-nexttrack.component.css
// module chunks = main